import Immutable from 'immutable';

import { ActionTypes } from './actions';

export const initialState = Immutable.fromJS({
  userAuthData: {},
});

const setAuthorizedUsers = (state, { authorizedUsersData }) => {
  if (!authorizedUsersData) return false;
  return state.merge({ authorizedUsersData });
};

const setUserRoles = (state, { userRolesData }) => {
  if (!userRolesData) return false;
  return state.merge({ userRolesData });
};

const setUserRoleDetails = (state, { userRoleDetailsData }) => {
  if (!userRoleDetailsData) return false;
  return state.merge({ userRoleDetailsData });
};

const setUserAreas = (state, { userAreasData }) => {
  if (!userAreasData) return false;
  return state.merge({ userAreasData });
};

const setUserNotifications = (state, { notificationSettingsData }) => {
  if (!notificationSettingsData) return false;
  return state.merge({ notificationSettingsData });
};

const setUserNotificationsLoaderStatus = (state, { notificationSettingsLoader }) => {
  return state.merge({ notificationSettingsLoader });
};

const setAuthorizedUsersLoaderStatus = (state, { authorizedUsersLoader }) => {
  return state.merge({ authorizedUsersLoader });
};

const setUserRoleDetailsLoaderStatus = (state, { UserRoleDetailsLoader }) => {
  return state.merge({ UserRoleDetailsLoader });
};

const setAppNotifications = (state, { appNotifications }) => {
  return state.merge({ appNotifications });
};

export const callbacks = [
  {
    actionType: ActionTypes.SET_AUTHORIZED_USERS,
    actionFunction: setAuthorizedUsers,
  },
  {
    actionType: ActionTypes.SET_USER_ROLES,
    actionFunction: setUserRoles,
  },
  {
    actionType: ActionTypes.SET_USER_ROLE_DETAILS,
    actionFunction: setUserRoleDetails,
  },
  {
    actionType: ActionTypes.SET_USER_AREAS,
    actionFunction: setUserAreas,
  },
  {
    actionType: ActionTypes.SET_USER_NOTIFICATIONS,
    actionFunction: setUserNotifications,
  },
  {
    actionType: ActionTypes.SET_USER_NOTIFICATIONS_LOADER_STATUS,
    actionFunction: setUserNotificationsLoaderStatus,
  },
  {
    actionType: ActionTypes.SET_AUTHORIZED_USERS_LOADER_STATUS,
    actionFunction: setAuthorizedUsersLoaderStatus,
  },
  {
    actionType: ActionTypes.SET_USER_ROLE_DETAILS_LOADER_STATUS,
    actionFunction: setUserRoleDetailsLoaderStatus,
  },
  {
    actionType: ActionTypes.SET_APP_NOTIFICATIONS,
    actionFunction: setAppNotifications,
  },
];
